import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the YyyymmddPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'hhiiss',
})
export class HhiissPipe implements PipeTransform {

  transform(value: number) {
    if (!value || value === 0) {
      return '-';
    }
    const now = new Date(value * 1000);
    return ( "0" + now.getHours() ).slice(-2) + '時' + ( "0" + now.getMinutes()).slice(-2) + '分' + ( "0" + now.getSeconds()).slice(-2) + '秒';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date/hhiiss.ts